import { Component, ViewChild, ElementRef, AfterViewInit, OnInit, OnDestroy } from '@angular/core';
import { LlModelsService } from '../ll-models.service';
import { jqxEditorComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxeditor';
import { jqxTextAreaComponent } from "jqwidgets-scripts/jqwidgets-ts/angular_jqxtextarea";

@Component({
  selector: 'll-model-reports-ai-statepayers',
  templateUrl: './ll-model-reports-ai-statepayers.component.html',
  styleUrls: ['../cssMain.css'],
})
export class LlModelReportsAiStatepayersComponent {


  @ViewChild('mainDiv_ll_model_reports_ai_statepayers') private mainDiv: ElementRef;

  constructor(
    private LlModelsService: LlModelsService,
  ) {

  }

  bundle = {
    showObj: false,
    spB: 0,
    objW: 0,
    objH: 0,
    editorX: 10,
    editorY: 30,
    editorW: 0,
    editorH: 0,
    REPORT_BODY:'',
  }

  ngOnDestroy() { }

  ngOnInit() { }

  ngAfterViewInit() {
    this.setVars();
  }

  setVars() {

    this.bundle.showObj = false;
    this.bundle.objW = this.mainDiv.nativeElement.parentElement.parentElement.clientWidth;
    this.bundle.objH = this.mainDiv.nativeElement.parentElement.parentElement.clientHeight;

    setTimeout(() => {

      this.bundle.editorW = this.bundle.objW - (this.bundle.editorX * 2)
      this.bundle.editorH = this.bundle.objH - this.bundle.editorY - 40;
      this.bundle.spB = this.bundle.editorY + this.bundle.editorH + 10;

      this.getData();


    });
  }

  getData() {

    this.LlModelsService.NG_LL_reports_AI_StatePayer_Overview(done01, this.bundle);

    function done01(arr, bundle) {

      if (arr.length > 0) {

        bundle.TEMPLATE = arr;

        setTimeout(() => {

          bundle.REPORT_BODY = arr[0].REPORT_BODY;
          bundle.showObj = true;
        });
      }
    }
  }
}
